import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <img 
          src="/uploads/hero.jpg" 
          alt="Anunobykush - A platform for cannabis-related insights and resources" 
          className="hero-image" 
        />
        <p className="eyebrow">Anunobykush</p>
        <h1>Your Source for Cannabis Policy and Culture</h1>
        <p className="lede">
          Stay informed with the latest updates on cannabis laws, policies, and cultural insights in your area.
        </p>
        <div className="cta-row">
          <a href="/resources" className="primary">
            Explore Information
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Local Cannabis Law Updates</h2>
          <p>
            Keep up with the latest changes in cannabis legislation and understand how they affect your community.
          </p>
        </article>
        <article>
          <h2>Understanding Legal Status</h2>
          <p>
            Gain clarity on the legal status of cannabis in your area, including regulations and compliance requirements.
          </p>
        </article>
        <article>
          <h2>Educational Resources</h2>
          <p>
            Access comprehensive guides and articles that educate on cannabis use, benefits, and responsible practices.
          </p>
        </article>
        <article>
          <h2>Cannabis Culture Coverage</h2>
          <p>
            Explore in-depth coverage of cannabis culture, including its history, social impact, and community stories.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;